import React from 'react'
import { Spacer, View } from 'oio-react'
import { settingsSiteUrl } from 'config/constants/urls'
import ProtoHeadingBlock from 'src/components/Settings/ProtoHeadingBlock'
import ProtoReturnBar from 'src/components/Settings/ProtoReturnBar'

const SettingsSiteDomain = () => (
   <View>
      <ProtoReturnBar
         display="block[a-d] none[e-f]"
         returnLinkName="Site Settings"
         returnLinkTo={settingsSiteUrl}
      />
      <View
         display="flex"
         justifyContent="center">
         <View
            width="100%"
            maxWidth="100%[a-c] 600px[d-f]"
            padding="40px 20px">
            <View
               width="100%"
               display="flex"
               flexFlow="column[a-c] row[d-f]">
               <View paddingRight="30px[b-c] 50px[d-f]">
                  <ProtoHeadingBlock
                     title="Domain & Hosting"
                     description="Configure the domain and hosting settings for this Site"
                  />
               </View>
            </View>
            <Spacer size="3" />
            <View
               width="100%"
               marginTop="24px"
               borderRadius="6px"
               padding="24px"
               backgroundColor="#fff">
               Coming Soon
            </View>
         </View>
      </View>
   </View>
)

export default SettingsSiteDomain
